import { render, staticRenderFns } from "./historypackages.vue?vue&type=template&id=0a1fcac2&"
import script from "./historypackages.vue?vue&type=script&lang=js&"
export * from "./historypackages.vue?vue&type=script&lang=js&"
import style0 from "./historypackages.vue?vue&type=style&index=0&id=0a1fcac2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports